// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-page[data-v-e0286824] {
  height: 100vh !important;
  width: 100%;
  background-color: var(--e0286824-\\\$getStyles\\.background);
}
.full-page[data-v-e0286824] .row {
  overflow-y: auto !important;
}
.panel[data-v-e0286824] {
  padding: var(--e0286824-\\\$getStyles\\.panelPadding);
  position: relative;
}
.panel.left-panel[data-v-e0286824] {
  background: var(--e0286824-\\\$getStyles\\.leftPanelbackground);
}
.absolute-top[data-v-e0286824] {
  position: absolute;
  top: 20px;
}
.absolute-top.right[data-v-e0286824] {
  right: 20px;
}
.absolute-top.left[data-v-e0286824] {
  left: 20px;
}
.extraLarge[data-v-e0286824] {
  font-size: var(--e0286824-\\\$getStyles\\.extraLargeFontSize);
}
.extraLarge[data-v-e0286824]:hover {
  font-size: var(--e0286824-\\\$getStyles\\.extraLargeFontSize);
}
.large[data-v-e0286824] {
  font-size: var(--e0286824-\\\$getStyles\\.largeFontSize);
}
.large[data-v-e0286824]:hover {
  font-size: var(--e0286824-\\\$getStyles\\.largeFontSize);
}
.auth-form[data-v-e0286824] {
  margin: 0 auto;
  padding: 0 10px 10px 10px;
  position: sticky;
  top: 0;
  z-index: 1;
}
.auth-form div[data-v-e0286824] {
  width: 600px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/Auth.vue","webpack://./Auth.vue"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,WAAA;EACA,yDAAA;ACDF;ADGE;EACE,2BAAA;ACDJ;ADKA;EACE,kDAAA;EACA,kBAAA;ACFF;ADIE;EACE,4DAAA;ACFJ;ADMA;EACE,kBAAA;EACA,SAAA;ACHF;ADKE;EACE,WAAA;ACHJ;ADME;EACE,UAAA;ACJJ;ADQA;EACE,0DAAA;ACLF;ADOE;EACE,0DAAA;ACLJ;ADSA;EACE,qDAAA;ACNF;ADQE;EACE,qDAAA;ACNJ;ADUA;EACE,cAAA;EACA,yBAAA;EAEA,gBAAA;EACA,MAAA;EACA,UAAA;ACRF;ADUE;EACE,YAAA;EACA,cAAA;ACRJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.full-page {\n  height: 100vh !important;\n  width: 100%;\n  background-color: v-bind('$getStyles.background');\n\n  &:deep(.row) {\n    overflow-y: auto !important;\n  }\n}\n\n.panel {\n  padding: v-bind('$getStyles.panelPadding');\n  position: relative;\n\n  &.left-panel {\n    background: v-bind('$getStyles.leftPanelbackground');\n  }\n}\n\n.absolute-top {\n  position: absolute;\n  top: 20px;\n\n  &.right {\n    right: 20px;\n  }\n\n  &.left {\n    left: 20px;\n  }\n}\n\n.extraLarge {\n  font-size: v-bind('$getStyles.extraLargeFontSize');\n\n  &:hover {\n    font-size: v-bind('$getStyles.extraLargeFontSize');\n  }\n}\n\n.large {\n  font-size: v-bind('$getStyles.largeFontSize');\n\n  &:hover {\n    font-size: v-bind('$getStyles.largeFontSize');\n  }\n}\n\n.auth-form {\n  margin: 0 auto;\n  padding: 0 10px 10px 10px;\n\n  position: sticky;\n  top: 0;\n  z-index: 1;\n\n  div {\n    width: 600px;\n    margin: 0 auto;\n  }\n}\n",".full-page {\n  height: 100vh !important;\n  width: 100%;\n  background-color: v-bind(\"$getStyles.background\");\n}\n.full-page:deep(.row) {\n  overflow-y: auto !important;\n}\n\n.panel {\n  padding: v-bind(\"$getStyles.panelPadding\");\n  position: relative;\n}\n.panel.left-panel {\n  background: v-bind(\"$getStyles.leftPanelbackground\");\n}\n\n.absolute-top {\n  position: absolute;\n  top: 20px;\n}\n.absolute-top.right {\n  right: 20px;\n}\n.absolute-top.left {\n  left: 20px;\n}\n\n.extraLarge {\n  font-size: v-bind(\"$getStyles.extraLargeFontSize\");\n}\n.extraLarge:hover {\n  font-size: v-bind(\"$getStyles.extraLargeFontSize\");\n}\n\n.large {\n  font-size: v-bind(\"$getStyles.largeFontSize\");\n}\n.large:hover {\n  font-size: v-bind(\"$getStyles.largeFontSize\");\n}\n\n.auth-form {\n  margin: 0 auto;\n  padding: 0 10px 10px 10px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.auth-form div {\n  width: 600px;\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
